import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDashboardLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDashboardLow"><Path d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.0452 21.8396 14.053 21.5422 15H12.618L9.44721 8.65836L7.65836 9.55279L10.382 15H2.4578C2.16035 14.053 2 13.0452 2 12Z" fill="currentColor"/><Path d="M3.33594 17C5.06498 19.989 8.2967 22 11.9981 22C15.6995 22 18.9312 19.989 20.6603 17H3.33594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDashboardLow;
